import 'vue-select/dist/vue-select.css'
// import '@/@assets/scss/libs/select2.css'
import vSelect from 'vue-select'
export default vSelect
